import styled, { css } from 'styled-components';

export const Wrapper = styled.dl`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(4)};
    width: 100%;
    margin: 0;
  `}
`;
